import type { SearchkitWrapperProps } from '@uncinc/react-searchkit/dist/components/Wrapper';

const facetQuery = (field: string, size: number) => ({
  terms: {
    field,
    size,
    min_doc_count: 0,
  },
});

export const resultAttributes = [
  'type',
  'created',
  'url',
  'page_title',
  'body_summarized',
  'image_style_uri',
  'article_type',
  'article_type_id',
  'article_read_time',
  'event_date',
  'event_date_end_value',
  'event_date_infinite',
  'link',
  'computed_first_upcoming_date_index',
];

export const facetAttributes: SearchkitWrapperProps['searchSettings']['facet_attributes'] = [
  {
    attribute: 'type',
    field: 'type',
    type: 'string',
    facetQuery,
  },
  {
    attribute: 'targetAudience',
    field: 'target_audience',
    type: 'string',
    facetQuery,
  },
  {
    attribute: 'theme',
    field: 'theme',
    type: 'string',
  },
  {
    attribute: 'article_type',
    field: 'article_type',
    type: 'string',
  },
];
